import { StarFilledIcon, StarIcon } from "@radix-ui/react-icons";
import React, { useMemo } from "react";
import { cn } from "../../utils/cn";
import { useTranslation } from "react-i18next";

interface PasswordSafetyCardProps {
  passwordValidation: {
    length: boolean;
    uppercase: boolean;
    lowercase: boolean;
    number: boolean;
    specialChar: boolean;
  };
}

const PasswordSafetyCard = ({
  passwordValidation,
}: PasswordSafetyCardProps) => {
  const { i18n } = useTranslation();

  const validationOrder = useMemo(
    () => [
      passwordValidation.length,
      passwordValidation.uppercase,
      passwordValidation.lowercase,
      passwordValidation.number,
      passwordValidation.specialChar,
    ],
    [
      passwordValidation.length,
      passwordValidation.lowercase,
      passwordValidation.number,
      passwordValidation.specialChar,
      passwordValidation.uppercase,
    ]
  );

  const filledStarsCount = useMemo(
    () => validationOrder.filter(Boolean).length,
    [validationOrder]
  );

  return (
    <div
      className={cn(
        "flex items-center justify-between absolute -bottom-[15px]",
        i18n.language === "en" ? " right-0" : "left-0"
      )}
    >
      <div />
      <div className="flex items-center gap-0.5">
        {Array.from({ length: 5 }).map((_, index) =>
          index < filledStarsCount ? (
            <StarFilledIcon key={index} />
          ) : (
            <StarIcon key={index} />
          )
        )}
      </div>
    </div>
  );
};

export default React.memo(PasswordSafetyCard);
